export type ContentDataSource = 'tmdb' | 'xtream';

const KEY = 'ott_content_data_source';

export function getContentDataSource(): ContentDataSource {
  const stored = localStorage.getItem(KEY);
  if (stored === 'xtream') return 'xtream';
  return 'tmdb'; // default
}

export function setContentDataSource(source: ContentDataSource): void {
  localStorage.setItem(KEY, source);
}
